import React from 'react'
import { Stack } from 'rsuite'

const Footer = () => {
  return (
    <div>
        <Stack
        className="copyright"
        justifyContent="flex-end"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          paddingRight: '16px'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          {' '}
          <a href="https://erpdaddy.com/" target="_blank">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
    </div>
  )
}

export default Footer
